import type { TailwindPattern } from "../interface";

const screenReadersPattern: TailwindPattern = {
    base: /(not-)?sr-only/,
};

export default screenReadersPattern;

export const screenReadersSample = [["sr-only", "not-sr-only"]];
